import React from 'react';

export const subMenu = [
  {
    title: 'Danh sách mục tiêu',
    icon: <img src="content/images/icons/target.svg" />,
    key: 'objective',
    linkTo: '/objective',
  },
  {
    title: 'Danh sách công việc',
    icon: <img src="content/images/icons/plan.svg" />,
    key: 'activities',
    linkTo: '/activities',
  },
  {
    title: 'Tổ chức',
    icon: <img src="content/images/icons/organization.svg" />,
    key: 'organization',
    items: [{
      title: 'Sơ đồ tổ chức',
      key: 'sub-organization',
      linkTo: '/organization',
    }]
  },
  {
    title: 'Báo cáo',
    icon: <img src="content/images/icons/report.svg" />,
    key: 'reports',
    linkTo: '/reports',
  },
  {
    title: 'Báo cáo tuân thủ',
    icon: <img src="content/images/icons/report.svg" />,
    key: 'report-compliance',
    linkTo: '/report-compliance',
  },
  {
    title: 'Quản trị hệ thống',
    icon: <img src="content/images/icons/setting.svg" />,
    key: 'settings',
    items: [
      {
        title: 'Nhân sự',
        key: 'persons',
        linkTo: '/persons',
      },
      {
        title: 'Kỳ kế hoạch',
        key: 'plan-period',
        linkTo: '/plan-period',
      },
      {
        title: 'Kỳ dự thảo',
        key: 'draft-period',
        linkTo: '/draft-period',
      },
      {
        title: 'Kỳ báo cáo',
        key: 'report-schedule',
        linkTo: '/report-schedule',
      },
      {
        title: 'Cửa sổ lập kế hoạch năm',
        key: 'annual-plan-window',
        linkTo: '/annual-plan-window',
      },
      {
        title: 'Mảng công việc',
        key: 'work-type',
        linkTo: '/work-type',
      },
      {
        title: 'Danh sách dự án',
        key: 'projects',
        linkTo: '/projects',
      },
    ]
  }
];
